import React from "react";
import "./ContactsHeader.css"; // Custom styles
import "bootstrap/dist/css/bootstrap.min.css";

const ContactsHeader = () => {
  return (
    <div className="ContactsHeader  text-white text-center py-4">
      <div className="container">
        <div className="row  text-dark py-5 ContactsHeader-info">
          <div className="col-md-4 col-sm-6 text-center mb-4">
            <i className="fa fa-plane fa-3x  mb-3 travelicon"></i>
            <h5 className="fw-bold">From Airport</h5>
            <p>
              Take a taxi or ride-share via Mount-Poonamallee Rd → Maduravoyal
              Bypass. Approx. 35–45 min (20 km).
            </p>
          </div>
          <div className="col-md-4 col-sm-6 text-center mb-4">
            <i className="fa fa-train fa-3x  mb-3 travelicon"></i>
            <h5 className="fw-bold traveltitle">From Chennai Central</h5>
            <p>
              Route via Poonamallee High Road → Koyambedu → Vanagaram. Approx.
              30–40 min (17 km).
            </p>
          </div>
          <div className="col-md-4 col-sm-6 text-center mb-4">
            <i className="fa fa-subway fa-3x  mb-3 travelicon"></i>
            <h5 className="fw-bold traveltitle">From Egmore Station</h5>
            <p>
              Take route through Anna Nagar → Koyambedu → Vanagaram. Approx.
              25–35 min (15 km).
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactsHeader;
